import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import { CssBaseline, GlobalStyles, Theme } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { GamixProvider } from './context';

const Portal: React.FC<{
  document: Document
  theme: Theme,
  children?: React.ReactNode
}> = ({
  children,
  document,
  theme,
}) => {
  const cacheRtl = createCache({
    key: 'rtl-css',
    prepend: true,
    stylisPlugins: [rtlPlugin],
    container: document.head,
  });

  const cacheLtr = createCache({
    key: 'ltr-css',
    prepend: true,
    container: document.head,
  });

  return (
    <GamixProvider
      value={{
        window,
        container: document.body,
      }}
    >
      <CacheProvider value={theme.direction === 'rtl' ? cacheRtl : cacheLtr}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles styles={{
            html: {
              width: '100%',
              height: '100%',
              fontSize: '10px',
            },
            body: {
              width: '100%',
              height: '100%',
              margin: 0,
              overflow: 'hidden',
              padding: '0 !important',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              background: 'transparent',
            },
          }}
          />
          {children}
        </ThemeProvider>
      </CacheProvider>
    </GamixProvider>
  );
};

export default Portal;
